// First-person local review draft; earlier accepted source version backed up on FX2.
export const lorisBio = [
  {
    "id": "home",
    "title": "Professional overview",
    "source": "https://lorisholland.com/",
    "blocks": [
      {
        "type": "p",
        "text": "I’m a producer, songwriter, singer, keyboardist, performer, composer, arranger and conductor. My love of music has taken me across classical, jazz, R&B, adult contemporary, rock, reggae, calypso, country, gospel, CCM and hip-hop.\nDuring my journey, I’ve worked with a myriad of recording artists. I’ve also created music for jingles, television, movies and video games."
      },
      {
        "type": "p",
        "text": "I’ve contributed to recordings that have collectively sold over 100 million copies.\nIn various roles as a producer, songwriter, singer and musician, I’ve contributed to Grammy-winning projects by Deniece Williams, Al Green and Shirley Caesar, and Santana, as well as Lauryn Hill’s Album of the Year-winning The Miseducation of Lauryn Hill. I also won three Emmy Awards for my work as a composer on ABC’s All My Children."
      },
      {
        "type": "p",
        "text": "I began my musical training at the Ruby Holland School of Music, accredited by the Royal Schools of Music, London, England. I started at the age of two, developed as a pianist through my boyhood years and performed with a variety of popular bands from age 10. My studies at the Aaron Copland School of Music (CUNY) introduced me to New York’s musicians and music scene, profoundly shaping my musical life and setting the course for my career."
      },
      {
        "type": "p",
        "text": "Throughout my life, I’ve been blessed to take advantage of most times when I was at the right place at the right time with the right sound and the right key, and I’m deeply grateful for the privilege of working with amazing artists and musicians such as:"
      },
      {
        "type": "p",
        "text": "Marcus Miller, Mariah Carey, George Clinton, Whitney Houston, Aretha Franklin, Al Green, Anita Baker, Vanessa Bell Armstrong, Vanessa Williams, Macy Gray, Billy Ocean, Ruby Turner, Anthony Hamilton, Tramaine Hawkins, Walter Hawkins, Edwin Hawkins, Shirley Ceasar, Glenn Jones, Millie Jackson, The Winans, Vicky Winans, Jonathan Butler, Patti LaBelle, Smokey Robinson, Deniece Williams, Lauryn Hill, Carlos Santana, Maxi Priest, Karen White, Mary J. Blige, Mutt Lange, Donnie McClurkin, Randy Jackson, LL Cool J, Mary Chapin Carpenter, Tonex, The Duke Ellington Orchestra, Bebe Winans, Kenny Lattimore, Youthful Praise, BAM Crawford's Purpose, Faith No More, Celine Dion, James Ingram, Sheila E., The Roots, Rita Ora, The Goo Goo Dolls, Michael McDonald, R. Kelly, Rev. Run Formerly of Run DMC, Jeff Buckley, Antonio McClendon, and a host of others."
      },
      {
        "type": "p",
        "text": "I’ve learned from classical and jazz theory, from the streets, from the church and from the many cultures I’ve encountered. Each has added its own flavor, bringing spice to the fabric of the music I create. The more I learn, the more I see the mystery and how much there is still to learn. I marvel at music’s scientific precision and mathematical logic, and how it can stir our emotions, soothe us and massage the atmosphere we breathe. Its magnetism is always in motion, drawing these elements together to move us. For me, it all leads back to God, the source of this amazing gift we call music."
      }
    ]
  },
  {
    "id": "about",
    "title": "The Early Years",
    "source": "https://lorisholland.com/about.html",
    "blocks": [
      {
        "type": "subheading",
        "text": "Early Childhood"
      },
      {
        "type": "p",
        "text": "I grew up in Guyana, formerly British Guiana, the youngest member of a musical family. My grandfather was an amazing pianist who mastered every style. He taught classical piano by day and was a pipe organist for the Catholic church, but at night he preferred a good time playing ragtime piano in the local clubs. My grandmother was a violinist, and she never endorsed the popular nightclub music."
      },
      {
        "type": "p",
        "text": "My mother’s brother was the tenor attraction in the local opera society, and my mother was my grandfather’s apprentice and organist at a local church."
      },
      {
        "type": "p",
        "text": "My home was always filled with music. By day, it was The Ruby Holland School of Music, my mother’s conservatory. There were 6 pianos and my mother’s vocal students, and I was the cranky 2year old holding on to her dress. By late afternoon, when my father, an electrical engineer, returned from work, we went back to normal family life. My two older sisters were also enrolled in the school and helped my mother teach the beginners."
      },
      {
        "type": "subheading",
        "text": "Discovering the Piano"
      },
      {
        "type": "p",
        "text": "My family discovered my talent when I was around 4yrs. old. My sister Elizabeth was practicing Beethoven’s moonlight sonata for a recital. At another piano, I began playing the simple melody along with her for at least 16 bars before she stopped, shocked that I was playing by ear. Later, they discovered that I had perfect pitch, and my musical life was kick-started."
      },
      {
        "type": "p",
        "text": "From that time I remember playing the piano until I fell asleep on it every night. My mother taught me how to read music, but my ears were so developed, that I would learn the piece by simply hearing her play it, then act as if I was reading the notes, when I was actually playing by ear."
      },
      {
        "type": "p",
        "text": "I reminded my mother of her father and brother. Their separate tragic deaths, both linked to their lives in popular music, had left her deeply shaken. She became very protective of me, trying to keep me away from the music she associated with losing them."
      },
      {
        "type": "subheading",
        "text": "The Early Band Years"
      },
      {
        "type": "p",
        "text": "I was forbidden to play anything but classical or sacred music at home. So, when she wasn’t at home, naturally I did my thing. After school, on the way home, I would ride my bicycle by all local reggae band rehearsals, and listen to them rehearse from outside, wishing I could be a part of it. I was 11 years old at the time."
      },
      {
        "type": "p",
        "text": "My wish came true one day when I boldly told a local band member I could teach them the song they were struggling with. He thought he would embarrass me. To him, I was just one of the many fans gathered around the gates of their outdoor rehearsal every day."
      },
      {
        "type": "p",
        "text": "The band wanted me to join immediately…I said yes, not caring that my mother would forbid it. So my young teenage life went from band to band, since I had to leave each band once my mother found out. I earned a reputation as the amazing kid who could play anything, but only came to rehearsals and never showed up for the gig."
      }
    ],
    "caption": "Excerpts from my autobiography",
    "closingNote": "The story continues in my autobiography, currently in progress."
  }
];
